module.exports = function (getRestrictions, value) {
  const restrictions = getRestrictions('character_number');
  const textLength = removeLineBreaks(value).length || 0;

  if (restrictions.length) {
    const errorMessages = [];

    for (const i in restrictions) {
      const params = Object.assign({ value }, restrictions[i]);

      if (Number(restrictions[i].max) < textLength || Number(restrictions[i].min) > textLength) {
        errorMessages.push({ message: 'character_number_range', params });
      }
    }

    if (errorMessages.length) {
      throw errorMessages;
    }
  }

  return value;

  function removeLineBreaks (value) {
    return value.replace(/(\r\n|\n|\r)/g, '');
  }
};
